import {gsap} from "gsap";
import {ScrollTrigger} from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)
var module = () => import('./../helpers/smooth-scroll-to');
const animations = {
  cursor: () => import('./../animations/cursor')
},
helpers = {
    updateSmoothScroll: () => import('./../helpers/smooth-scroll-update'),
 },
closeForm = document.querySelector('.layer-mouse-move')
export const formController = () => {


	const cursor = document.querySelector('.form__cursor')
  	if (cursor) {
  	  animations.cursor().then(module => module.customCursor(cursor, closeForm, false,false,false))
  	}


  	if($("body").hasClass("single-yacht") && $(".text-launch .btn--form[data-id='moreinfo']").length < 1 && $(".text-launch .btn--form[data-id='keepupdated']").length < 1) {
  		$(".yacht__design__end").remove();
  	}
  	if($(".text-launch .btn--form[data-id='keepupdated']").length > 0) {
  		$(".cta-last-form-design").attr("data-id","keepupdated");
  		$(".cta-last-form-design span").text($(".cta-last-form-design").attr("data-updated"));
  	}

	function readCookie(name) {
    return (name = new RegExp('(?:^|;\\s*)' + ('' + name).replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') + '=([^;]*)').exec(document.cookie)) && name[1];
	}
	$(".safari.touch .single-yacht div#intro-map,.safari.touch .single-yacht div#design-map").remove();
   var number_of_yachts = readCookie('yachts-saw')
	 if($("#newsletterpopup").length > 0 && number_of_yachts == "4") {
	 	setTimeout(function() {
	 	gsap.to($("#newsletterpopup"), {
	    display: 'block',
	    duration: 0,
		 });

		 gsap.to($("#newsletterpopup"), {
	    clipPath: 'inset(0% 0% 0% 0%)',
	    duration: .7,
		 });
		 gsap.to($("#newsletterpopup .inner-form"), {
	    opacity: 1,
	    delay: .9,
	    duration: 1,
		 });
	   gsap.to($(".close-form"), {
	     opacity: 1,
	     rotate: 0,
	     delay: 0.8
	   })
	 	}, 3000);

	 } else {
	 	$("#newsletterpopup").remove();
	 }
	$.fn.serializeObject = function(){
	    var obj = {};

	    $.each( this.serializeArray(), function(i,o){
	      var n = o.name,
	        v = o.value;

	        obj[n] = obj[n] === undefined ? v
	          : $.isArray( obj[n] ) ? obj[n].concat( v )
	          : [ obj[n], v ];
	    });

	    return obj;
	  };
	var criteria = "";
	var country_load = false;
	var product_load = false;
	function loadCountry() {
		if(!country_load) {
			var language = $('input[name="language"]').first().val();
			jQuery.ajax({
		   	 url: ajaxurl,
		   	 method: 'POST',
		   	 data: {
		   	     action: 'functions',
		   	     function: 'get_country',
				 		 data: {language}
		   	 },
		   	 success: function (response) {
		   	 	country_load = true;
		   	 	$('select[name="country"], select[name="docking-country"]').append(response);
		   	 },
		   	 error: function(XMLHttpRequest, textStatus, errorThrown) {
					// console.log("Status: " + textStatus,"Error: " + errorThrown);
			 },
			});
		}
	}
	function loadProducts() {
		if(!product_load) {
			jQuery.ajax({
		   	 url: ajaxurl,
		   	 method: 'POST',
		   	 data: {
		   	     action: 'functions',
		   	     function: 'get_products_azimut',
				 		 data: {}
		   	 },
		   	 success: function (response) {
		   	 	product_load = true;
		   	 	$('select[name="model-brand-azimut"]').append(response);
		   	 },
		   	 error: function(XMLHttpRequest, textStatus, errorThrown) {

			 },
			});
		}
	}

	function setCriteria() {
		if(!criteria) {
			jQuery.ajax({
		   	 url: ajaxurl,
		   	 method: 'POST',
		   	 data: {
		   	     action: 'functions',
		   	     function: 'get_criteria',
				 		 data: {}
		   	 },
		   	 success: function (response) {
		   	 	criteria = response;
		   	 	$("input[name='criteria']").val(criteria);
		   	 },
		   	 error: function(XMLHttpRequest, textStatus, errorThrown) {
					// console.log("Status: " + textStatus,"Error: " + errorThrown);
			 },
			});
		}
	}

	if($(".body-landing").length > 0 || $(".page-template-form-page").length > 0 || $("#newsletterpopup").length > 0) {
		setCriteria();
	}


	$(document).on("click",".btn--form", function(e){

		if($(".body-landing").length < 1 && $(".page-template-form-page").length < 1) {
			loadCountry();
			loadProducts();
		}
		setCriteria();
	 e.preventDefault();
	  gsap.to($("#"+$(this).attr("data-id")), {
	    display: 'block',
	    duration: 0,
		 });
		 gsap.to($("#"+$(this).attr("data-id")), {
	    clipPath: 'inset(0% 0% 0% 0%)',
	    duration: .7,
		 });
		 gsap.to($("#"+$(this).attr("data-id")+" .inner-form"), {
	    opacity: 1,
	    delay: .9,
	    duration: 1,
		 });
	   gsap.to($(".close-form"), {
	     opacity: 1,
	     rotate: 0,
	     delay: 0.8
	   });
	    gsap.to($(".layer-mouse-move"), {
	     display: "block",
	     delay: 1
	   });
	    gsap.to($(".form__cursor"), {
	     opacity: 0,
	     delay: 1
	   });

		 return false;
	});

	$(document).on("click",".close-form,.layer-mouse-move", function(e){
	 e.preventDefault();
		 gsap.to($(".overlay-form"), {
	    clipPath: 'inset(0% 100% 0% 0%)',
	    duration: .7,
		 });
		 gsap.to($(".inner-form"), {
	    opacity: 0,
	    delay: 0.7,
	    duration: .7,
		 });

		 gsap.to($(".overlay-form"), {
	    display: "none",
	    delay: 1.4,
	    duration: 0,
		 });

	   gsap.to($(".close-form"), {
	     opacity: 0,
	     rotate: '-90deg',
	     delay: 0
	   });
	    gsap.to($(".layer-mouse-move"), {
	     display: "none",
	     delay: 0
	   });

	    gsap.to($(".form__cursor"), {
	     opacity: 0,
	   });



		 return false;
	});


	$(document).on("change",".condition-parent", function(){
	 var parentForm = $(this).closest(".form"),
	 fieldName = $(this).attr("name"),
	 fieldValue = $(this).val();
	 $(".field[data-condition='"+fieldName+"'] select",parentForm).val("");
	 $(".field[data-condition='"+fieldName+"'] input",parentForm).val("");
	 $(".field[data-condition='"+fieldName+"'] select",parentForm).trigger("change");
	 $(".field[data-condition='"+fieldName+"']",parentForm).removeClass("show-condition");
	 $(".field[data-condition='"+fieldName+"'][data-value*='"+fieldValue+"']",parentForm).addClass("show-condition");
	});
	$(document).on("change","select", function(){
		$(this).addClass("filled");
	});

	$(document).on("change",".country-field select", function(){
		var id_select = $(this).attr("id");
		var select_state = $("#state-"+id_select);
		var select_stateParent = $("#state-"+id_select).closest(".condition-state");
		select_stateParent.removeClass("show-condition");
		select_state.empty();
		if($("option:selected",this).attr("data-sub") == "1") {
			select_stateParent.addClass("show-condition");
			var country_selected = {
				guid : $(this).val()
			};
			jQuery.ajax({
		   	 url: ajaxurl,
		   	 method: 'POST',
		   	 data: {
		   	     action: 'functions',
		   	     function: 'get_states',
				 		 data: country_selected
		   	 },
		   	 success: function (response) {
		   	 	select_state.html(response);
		   	 	//PRE FILL CRM USER
		   	 	document.dispatchEvent(new CustomEvent('stateChange', {detail: {select_state}}));
		   	 },
		   	 error: function(XMLHttpRequest, textStatus, errorThrown) {
					//console.log("Status: " + textStatus,"Error: " + errorThrown);
			 },
			});
		}
	});

	// CHANGE MODELS ON CHANGE SELECT - LANDING CHANGE INFO
	if($("select[name='series']").length > 0) {
		var series_models = [];
		$("select[name='serie-models'] option").each(function(index){
			if($(this).val())
				series_models.push([$(this).val(),$(this).text(),$(this).attr("data-serie")]);
		});
		$(document).on("change","select[name='series']", function(e){
			var id_serie = $("option:selected",this).attr("data-id");
		 	$("select[name='serie-models']",$(this).closest(".form")).attr("disabled",false);
			$("select[name='serie-models']",$(this).closest(".form")).empty();
			$("select[name='serie-models']").append("<option disabled value='' selected></option>");
			series_models.forEach(element => {
				if(element[2] == id_serie)
					$("select[name='serie-models']").append(new Option(element[1], element[0]));
			});
		});
	}



	$(document).on("focusout","input,select,textarea", function(e){
	  if($(this).val()) {
		  $(this).closest(".field").removeClass("error");
	  }
	});
	$(document).on("submit",".form-lead",function(e){
	 e.preventDefault();
	 var send = true;
	 $(".error").removeClass("error");
	 var parentForm = $(this);
	 var form_name = $("input[name='action']",this).val();
	 $(".mandatory",parentForm).each(function(index){
		 if($(this).closest(".condition").length > 0 && $(this).closest(".show-condition").length < 1) return;
		 if(!$(this).val()) {
			 $(this).closest(".field").addClass("error");
			 send = false;
		 }
	 });
	 $("input[type='radio'].mandatory,input[type='checkbox'].mandatory",parentForm).each(function(index){
		 if($(this).closest(".condition").length > 0 && $(this).closest(".show-condition").length < 1) return;
		 if($("input[name='"+$(this).attr("name")+"']:checked",parentForm).length < 1) {
			 $(this).closest(".field").addClass("error");
			 send = false;
		 }
	 });


	 if(send) {
	 	var formValues = parentForm.serializeObject();
	 	var criteria = $("input[name='criteria']",parentForm).val();
	 	parentForm.closest(".form-full-container").addClass("loading");
	 	jQuery.ajax({
		    url: ajaxurl,
		    method: 'POST',
		    data: {
		      action: 'functions',
		      function: 'check_criteria',
					data: {criteria}
		    },
		    success: function (isOk) {
		    	//parentForm.closest(".form-full-container").removeClass("loading");
		    	gsap.to(parentForm, {
	 					  opacity: 0,
	 					  duration: 0.7
	 					});
					if(isOk == "true") {
						parentForm.closest(".form-full-container").addClass("sent");
						setTimeout(function () {
							parentForm.closest(".form-full-container").addClass("show-ok");
							ScrollTrigger.refresh()
    					helpers.updateSmoothScroll().then(module => module.smoothScrollUpdate())
						}, 750);
	 					gsap.to($(".form-submitted",parentForm.closest(".form-full-container")), {
	 					  opacity: 1,
	 					  duration: 0.7,
						  delay: 0.8
	 					});

	 					//TRACKING GTM :_D
	 					var newsletter_check = null;
	 					var commercial_check = null;
	 					if(!$("input[name='privacy-policy']",parentForm).hasClass("mandatory") && $("input[name='privacy-policy']",parentForm).length > 0) {
	 						newsletter_check = ($("input[name='privacy-policy']",parentForm).is(":checked")) ? "si" : "no";
	 					}
	 					if(!$("input[name='commercial']",parentForm).hasClass("mandatory") && $("input[name='commercial']",parentForm).length > 0) {
	 						commercial_check = ($("input[name='commercial']",parentForm).is(":checked")) ? "si" : "no";
	 					}

	 					document.dispatchEvent(new CustomEvent('formSent', {detail: {form_name,newsletter_check,commercial_check}}));

						jQuery.ajax({
						    url: ajaxurl,
						    method: 'POST',
						    data: {
						      action: 'functions',
						      function: 'save_lead',
									data: formValues
						    },
						    success: function (response) {
						    	//console.log(response);
									//SENT
						    },
						    error: function(XMLHttpRequest, textStatus, errorThrown) {
								//console.log("Status: " + textStatus,"Error: " + errorThrown);
								gsap.to($(".form-not-submitted",parentForm.closest(".form-full-container")), {
	 							  opacity: 1,
	 							  duration: 0.7,
								  delay: 0.8
	 							});
	 							setTimeout(function() {parentForm.closest(".form-full-container").addClass("not-sent");}, 750);
							},
						});
					} else {
						gsap.to($(".form-not-submitted",parentForm.closest(".form-full-container")), {
	 					  opacity: 1,
	 					  duration: 0.7,
						  delay: 0.8
	 					});
	 					setTimeout(function() {
	 						 parentForm.closest(".form-full-container").addClass("not-sent");
	 						 ScrollTrigger.refresh()
    					 helpers.updateSmoothScroll().then(module => module.smoothScrollUpdate())
	 				}, 750);
					}
		 },
		    error: function(XMLHttpRequest, textStatus, errorThrown) {
				//console.log("Status: " + textStatus,"Error: " + errorThrown);
				gsap.to($(".form-not-submitted",parentForm.closest(".form-full-container")), {
	 			  opacity: 1,
	 			  duration: 0.7,
				  delay: 0.8
	 			});
	 			setTimeout(function() {
	 				parentForm.closest(".form-full-container").addClass("not-sent");
	 				ScrollTrigger.refresh()
    			helpers.updateSmoothScroll().then(module => module.smoothScrollUpdate())
	 			}, 750);
			},
		});


	 } else {
		 if($(".form-container-in-page").length > 0) {
			 var element = $(".error input",parentForm).first();
			 if(!element) { $(".error select",parentForm).first() }
			 module().then(module => module.smoothScrollTo("#"+element.attr("id"), 500, -100));
		 } else {
			 $(this).closest(".inner-form").animate({scrollTop: $(".error",parentForm).first().position().top + parentForm.closest(".inner-form").scrollTop() - 30}, 'slow');
		 }
	 }

	 return false;
	});


}
